module.exports = __webpack_public_path__ + "img/bin-icon.9705c416.svg";